<template>
  <!--- 右边快速导航 -->
  <aside class="ys_aside_right">
    <ul>
      <li
        @click="$bus.$emit('registerPopup')" v-if="!sysInfo.sys_id||sysInfo.sys_id==11"
      >
        <i class="iconfont icontxt">&#xe6bc;</i>
        注册
      </li>
      <!-- <li
        :class="{ active: hotInto}"
        v-scrollTo="'hot_container'"
        v-if="pathUrl === '/index'"
      >
        渠道热销
      </li> -->
      <li
        :class="{ active: !hotInto && classifyInto }"
        v-scrollTo="'classify_container'"
        v-if="pathUrl === '/index'" style="padding:20px 0"
      >
        <i class="iconfont iconbj">&#xe622;</i>
        分类推荐
      </li>
      <li
        @click="navTo('/manager/goodsNew/goodsList','',true)"
      >
        <i class="iconfont iconbj">&#xe628;</i>
        选品库
      </li>
      <li @click="navTo('/cart')" v-if="sysInfo.sys_id&&sysInfo.sys_id!=11">
        <i class="iconfont iconbj">&#xe60f;</i>
        购物车
      </li>
      <li v-scrollTo>
        <i class="el-icon-arrow-up"></i>
        顶部
      </li>
    </ul>
  </aside>
</template>

<script>
import {mapState} from 'vuex'
export default {
  name: "ys-aside-right",
  data() {
    return {
      asideList: [],
      hotInto: false,
      classifyInto: false,
    };
  },
  computed: {
    ...mapState(['sysInfo']),
    pathUrl() {
      return this.$route.path;
    },
  },
  mounted() {
    this.$bus.$on("indexObserve", ({ into, type }) => {
      this[type + "Into"] = into;
    });
  },
};
</script>

<style scoped lang="scss">
/* 侧导航 */
.ys_aside_right {
  --media-width: 1600px;

  background-color: #fff;
  font-size: 14px;
  position: fixed;
  right: -3px;
  bottom: calc(50% - 132px);
  width: 82px;
  text-align: center;
  // padding: 10px 0 20px;
  border-radius: 10px 0 0 10px;
  z-index: 99;
  box-shadow: 0 0 10px 0 #9f9f9f63;
  // border: 3px solid var(--theme-color);
  user-select: none;

  ul {
    padding: 0;
    margin: 0;
    list-style: none;

    li {
      cursor: pointer;
      position: relative;
      padding: 12px 0;
      img,i {
        display: block;
        margin: 0 auto;
        &.icontxt{
          width: 30px;
          height: 30px;
          line-height: 30px;
          font-size: 30px;
          color: var(--theme-color);
          border-radius: 50%;
        }
        &.iconbj{
          background-color: var(--theme-color);
          color: #fff;
          border-radius: 50%;
          width: 28px;
          height: 28px;
          line-height: 28px;
          font-size: 19px;
        }
      }
    }

    li ~ li::before {
      content: "";
      position: absolute;
      top: 0;
      left: calc(50% - 30px);
      width: 60px;
      height: 0px;
      border: 1px solid;
      border-image: linear-gradient(315deg, #ff244200, #ededed, #ff244200) 1 1;
    }

    li:hover,
    li.active {
      color: var(--theme-color);
    }
  }
}

@media (max-width: $mediaWidth) {
  .ys_aside_right {
    --media-width: 998px;
  }
}

@media (max-width: 1600px) {
  // .ys_aside_right {
  //   right: 10px;
  // }
}
</style>
